<template>
	<div class="container-fluid bg-white">
		<toolbar>
			<router-link to="/financial" class="btn btn-link">
				<i class="fa fa-caret-left fa-2x"></i>
				<h2>Financial</h2>
			</router-link>

			<div class="controls">
				<router-link to="/invoice/new/details" class="btn btn-primary">
					<i class="fa fa-plus"></i>
					New Invoice
				</router-link>

				<search-bar 
					placeholder="Search invoices..."
					v-on:submit="searchInvoices">
				</search-bar>

				<financial-nav-tabs></financial-nav-tabs>
			</div>

		</toolbar>

		<collapsible-panel panel-size="md" :external-toggle="panelVisible" v-on:panelRetract="panelVisible = false">

			<template slot="panel">
				<h3>Filtering</h3>

				<field label="Customer"
					col-class="stacked"
					:params="{type:'select',options:$store.customerOptions}"
					v-model="customerFilter">
				</field>

				<form-group label="Amount Total"
					col-class="stacked">
					<div class="row no-gutters">
						<div class="col-6">
							<field 
								:params="{type:'number',placeholder:'Min'}"
								v-model="filterMinAmount">
							</field>
						</div>
						<div class="col-6">
							<field :params="{type:'number',placeholder:'Max'}"
								v-model="filterMaxAmount">
							</field>
						</div>
					</div>
				</form-group>

				<form-group label="Issue Date (from-to)"
								col-class="stacked">
					<div class="row no-gutters">
						<div class="col-6">
							<field
								:params="{type:'date'}"
								v-model="filterIssueDateFrom">
							</field>
						</div>
						<div class="col-6">
							<field
								:params="{type:'date'}"
								v-model="filterIssueDateTo">
							</field>
						</div>
					</div>
				</form-group>

				<field label="Job Type"
					col-class="stacked"
					:params="{type:'select',options:[
						{value: false,text:'All'},
						{value: 'service',text:'Service'},
						{value: 'project', text:'Project'}
					]}"
					v-model="filterJobType">
				</field>

				<form-group v-if="filterJobType == 'service'"
					label="Service # Range"
					col-class="stacked">

					<div class="d-flex">
						<field v-model="filterServiceRangeStart"
							:params="{type:'text',placeholder:'Range Start'}">		
						</field>
						<field v-model="filterServiceRangeEnd"
							:params="{type:'text',placeholder:'Range End'}">		
						</field>
					</div>

					<small class="text-muted">If Service #s contain alpha-numeric characters this filter may return consistent results</small>

				</form-group>

				<field
					label="Show only un-pushed to QBO"
					col-class="col-auto"
					:params="{type:'boolean'}"
					v-model="filterQBOUnpushed">
				</field>

				<button class="btn btn-primary mr-1" v-on:click="filterChange">Apply</button>

				<button class="btn btn-light" v-on:click="clearFilters">
					<i class="fa fa-ban"></i>
					Clear Filters
				</button>

			</template>
		
			<template slot="main">
				<h3>Invoices</h3>

				<table-list
					record-name="Invoice"
					:fields="mutatedFields"
					:records="mutatedInvoices"
					id-field="slug"
					:sortable="true"
					:has-edit="true"
					:total-paginated-records="numInvoices"
					:records-selectable="true"
					:other-buttons="[
						{
							text: 'Process',
							click: 'process',
							condition: ['isProcessable',true],
							class: 'btn-primary'
						},
						{
							text: 'Un-Process',
							click: 'unprocess',
							condition: ['is_processed',1],
							class: 'btn-light'
						}
					]"
					v-on:process="singleToggle($event,'is_processed',1)"
					v-on:unprocess="singleToggle($event,'is_processed',0)"
					v-on:selectedRecordsChange="recordsSelected"
					v-on:edit="editInvoice">

					<field 
						:params="{type:'btn-group',buttons:timeFilterButtons,tabStyling:true}" 
						v-model="invoiceFilter" 
						v-on:change="filterChange">		
					</field>

					<div class="d-flex flex-row align-items-center mt-2">

						<div class="d-flex mr-2">
							<button class="btn btn-light mr-2" :disabled="panelVisible" v-on:click="panelVisible = true">
								<i class="fa fa-filter"></i>
								Filter
							</button>

							<button :disabled="!mutatedInvoices || !mutatedInvoices.length" class="btn btn-light" v-on:click="exportInvoices">
								<i class="fa fa-download"></i>
								Export as CSV
							</button>
						</div>


						<div v-if="invoicesSubset.length > 0" class="d-flex flex-row flex-wrap align-items-center">
							<div class="mr-3">Mark {{invoicesSubset.length}} invoice{{invoicesSubset.length > 1 ? 's' : ''}} as</div>

							<button class="btn btn-dark btn-sm" v-on:click="bulkToggle('is_processed',1)">
								Processed
							</button>

							<button class="btn btn-light btn-sm" v-on:click="bulkToggle('is_processed',0)">
								Un-Processed
							</button>
	
							<button class="btn btn-success btn-sm" v-on:click="bulkMarkPaid">
								Paid
							</button>
							

						</div>

					</div>

				</table-list>

				<div class="text-center" v-if="mutatedInvoices.length > 0 && numPages > page">
					<button class="btn btn-light" type="button" v-on:click="loadMore">
						Load More
					</button>
				</div>

				<!--
				<pagination 
					v-if="page"
					:pages="numPages" 
					:current-page="page"
					v-on:pageChange="pageChange">
				</pagination>
				-->
			</template>

		</collapsible-panel>

	</div>
</template>

<script>

import Toolbar from "@/layout_fragments/Toolbar"
import FinancialNavTabs from "@/pages/financial/FinancialNavTabs"
import TableList from "@/components/TableList"
import Field from "@/components/Field"
//import Pagination from "@/components/Pagination"
import SearchBar from "@/components/SearchBar"
import FormGroup from "@/components/FormGroup"

import CollapsiblePanel from "@/layout_fragments/CollapsiblePanel"

import InvoiceMixins from "@/mixins/InvoiceMixins.js"

export default {

	name: 'Invoices',
	components: {
		Toolbar,
		TableList,
		Field,
		//Pagination,
		SearchBar,
		CollapsiblePanel,
		FormGroup,
		FinancialNavTabs
	},
	mixins: [InvoiceMixins],
	data() {
		return {
			invoiceFilter: "all",
			customerFilter: null,
			filterMinAmount: null,
			filterMaxAmount: null,
			filterJobType: false,
			filterServiceRangeStart: null,
			filterServiceRangeEnd: null,
			filterIssueDateFrom: null,
			filterIssueDateTo: null,
			filterQBOUnpushed: false,
			timeFilterButtons: [
				//{text: "Draft",value:"draft"},
				{text: "All",value:"all"},
				//{text: 'Un-Processed',value:'unprocessed'},
				{text: "Current",value:"current"},
				{text: "Overdue <30d",value:0},
				{text: "Overdue 30-60d",value:30},
				{text: "Overdue 60-90d",value:60},
				{text: "Overdue +90d",value:90},
				{text: "Paid",value:'paid'},
				//{text: "Processed",value:'processed'},
			],
			statusFilterButtons: [],
			fields: [
				{label: "Customer Name",key: "customerName",type:'link'},
				{label: "Contract #",key:"contractNum",type:"link"},
				{label: "Status",key:"status"},
				{label: "Invoice #",key: 'jobTypeNum',type:'link'},
				{label: "Amt. Pretax",key: 'pretaxTotalFormatted',sortBy:"float",align:"right"},
				{label: "Tax",key:'taxTotal',sortBy:"float",align:"right"},
				{label: "Amt. Total",key: 'grandTotalFormatted',sortBy:"float",align:"right"},
				{label: "Amt. Due",key:"amountDueFormatted",sortBy:"float",align:"right"},
				{label: "Amt. Paid",key:"amountPaidFormatted",sortBy:"float",align:"right"},
				{label: "Issue Date", key: "issueDate",sortBy:"date"},
				{label: "Due Date",key: "dueDate",sortBy:"date"},
				{label: "Age",key: 'age'},
				{label: "Seen by Customer",key: 'seenByCustomer',type:"boolean",align:'center'},
				{label: "Processed",key: 'is_processed',type:"boolean",align:'center'},
			],
			invoices: [],
			invoicesSubset: [],
			numInvoices: 0,
			numPages: 0,
			page: 1,
			panelVisible: false
		}
	},
	computed: {
		mutatedFields() {
			let fields = JSON.parse(JSON.stringify(this.fields))

			if (this.invoiceFilter == 'all')
				fields.push({
					label: "Paid",
					key: "is_paid",
					type: "boolean"
				})

			if (this.qboIsActive) {
				fields.push({
					label: "Pushed to QB",
					key: "pushedToQB",
					align: "center"
				})
			}
			
			return fields
		}
	},
	methods: {
		exportInvoices() {
			const fields = this.mutatedFields
			const headerRow = fields.map(field => field.label)

			const rows = this.mutatedInvoices.map(row => {
				let renderedRow = []

				fields.forEach(field => {

					if (row[field.key] === null || row[field.key] === undefined)
						renderedRow.push("")

					else if (typeof(row[field.key]) == 'object') {
						if ('text' in row[field.key] && row[field.key].text)
							renderedRow.push(row[field.key].text)
						else
							renderedRow.push("")

					} else if (field.key == 'status' && row.inRevision) {
						renderedRow.push("In Revision")

					} else if (typeof(row[field.key]) == 'string' && row[field.key].includes("<i class=")) {
						let boolVal = row[field.key]
						if (row[field.key].includes("fa-times"))
							boolVal = false
						else if (row[field.key].includes("fa-check"))
							boolVal = true
						renderedRow.push(boolVal)

					} else {
						renderedRow.push(row[field.key])
					}
				})

				return renderedRow
			})

			this.exportToCSV("Invoices.csv", [headerRow, ...rows])
		},
		recordsSelected(subset) {
			this.invoicesSubset = subset
		},
		singleToggle(record,field,value) {
			let vm = this

			let label = ""
			if (field == 'is_processed') 
				label = "Processed"
			else if (field == 'is_paid')
				label = "Paid"

			if (value == 0)
				label = "Un-"+label

			let payload = {
				id: record.id
			}

			payload[field] = value

			let resource = "ServiceInvoice"
			if ("Job" in record)
				resource = "JobInvoice"

			this.postData(resource+"/save",payload,true).then(response => {
				if (response.success) {
					vm.alertSuccess("Invoice toggled to '"+label+"'")
					vm.fetchInvoices()
				}
			})

		},
		bulkMarkPaid() {
			let vm = this

			let promises = []

			this.invoicesSubset
				.filter(inv => "Service" in inv && inv.Service || inv.is_freeform == 1)
				.forEach(inv => {
					let paymentAmount = +inv.grand_total - +inv.amount_paid

					let payload = {
						id: inv.id,
						payment_amount: paymentAmount
					}

					promises.push(this.postData("ServiceInvoice/payment",payload))
			})

			let jobInvRecords = []
			this.invoicesSubset
				.filter(inv => "Job" in inv && inv.Job)
				.forEach(inv => {

					jobInvRecords.push({
						id: inv.id,
						is_paid: 1
					})
				})

			promises.push(this.postData("JobInvoice/save-batch",{records: JSON.stringify(jobInvRecords)}))

			Promise.all(promises).then(responses => {

				let cnt = 0
				responses.forEach(response => {
					if ("record_id" in response && response.success)
						cnt++

					if ("data" in response && "records_saved" in response.data)
						cnt += response.data.records_saved
				})

				vm.alertSuccess(cnt + " invoices marked as paid")
				vm.fetchInvoices()
			})

		},
		bulkToggle(field,value) {
			let vm = this

			let label = ""
			if (field == 'is_processed') 
				label = "Processed"
			else if (field == 'is_paid')
				label = "Paid"

			if (value == 0)
				label = "Un-"+label

			let serviceRecords = this.invoicesSubset.filter(inv => "Service" in inv && inv.Service || inv.is_freeform == 1)
			let jobRecords = this.invoicesSubset.filter(inv => "Job" in inv && inv.Job)

			serviceRecords = serviceRecords.map(inv => {
				let record = {
					id: inv.id
				}

				record[field] = value
				record.skipQBOPush = true

				return record
			})

			jobRecords = jobRecords.map(inv => {
				let record = {
					id: inv.id
				}

				record[field] = value
				record.skipQBOPush = true

				return record
			})			

			let servicePayload = {
				records: serviceRecords
			}

			let jobPayload = {
				records: jobRecords
			}

			let promises = [
				this.postData("ServiceInvoice/save-batch",servicePayload),
				this.postData("JobInvoice/save-batch",jobPayload)
			]

			Promise.all(promises).then(responses => {
				let cnt = 0

				if (responses[0].success)
					cnt += +responses[0].data.records_saved
				if (responses[1].success)
					cnt += +responses[1].data.records_saved

				vm.alertSuccess(cnt + " invoices toggled to '"+label+"'")
				vm.fetchInvoices()
			})
		},
		editInvoice(record) {
			if ("GroupServices" in record && record.GroupServices)
				this.$router.push("/invoice/"+record.slug+"/details")
			else if ("Service" in record && record.Service)
				this.$router.push("/service/"+record.Service.slug+"/invoice")
			else if ("Job" in record && record.Job)
				this.$router.push("/project/"+record.Job.slug+"/billing/"+record.slug)
			else if ("ServiceContract" in record && record.ServiceContract)
				this.$router.push("/invoice/"+record.slug+"/details")
			else 
				this.$router.push("/invoice/"+record.slug+"/details")
		},
		clearFilters() {
			this.invoiceFilter = "all"
			this.customerFilter = null
			this.filterMinAmount = null
			this.filterMaxAmount = null
			this.filterIssueDateFrom = null
			this.filterIssueDateTo = null
			this.filterJobType = false
			this.filterServiceRangeStart = null
			this.filterServiceRangeEnd = null
			this.filterChange()
		},
		filterChange() {
			let vm = this

			this.page = 1

			this.$nextTick(() => {
				vm.fetchInvoices(true)
			})
		},
		pageChange(page) {
			this.page = page

			this.fetchInvoices(true)
		},
		loadMore() {
			this.page++

			this.fetchInvoices(true,false,true)
		},
		//flips service.ServiceInvoice to be invoice.Service, and returns the invoice object
		flipInvoiceAndService(service) {
			let invoice = {}
			if (service.ServiceInvoice.length > 0) {
				let theInvoice = service.ServiceInvoice.find(inv => inv.is_quote == 0)

				if (theInvoice)
					invoice = JSON.parse(JSON.stringify(theInvoice))

				delete service.ServiceInvoice
			}	

			invoice.Service = JSON.parse(JSON.stringify(service))

			return invoice
		},
		//flips service.ServiceInvoice to be invoice.Service, and returns the invoice object
		flipInvoiceAndJob(job) {
			let invoice = {}
			if (job.JobInvoice && job.JobInvoice.length > 0)
				invoice = JSON.parse(JSON.stringify(job.JobInvoice[0]))

			delete job.JobInvoice

			invoice.Job = JSON.parse(JSON.stringify(job))

			return invoice
		},
		searchInvoices(terms) {
			let vm = this

			//actually searching Services so we have better search ability
			let params = {
				filters: [
					["job_name",terms,"and","like"],
					["job_num",terms,"or","like"],
					['customer_po',terms,'or','like'],
					["city",terms,"or","like"],
					["address",terms,"or","like"],
					["postal_code",terms,"or","like"],
				],
				include: [
					{
						model: "JobInvoice",
						filters: [["is_active_version",1]],
					},
					{
						model:"ServiceInvoice",
						include:[
							"Contact",
							{model: "ServiceContract",fields: ["id","slug","contract_num","contract_description"]}
						]
					},
					"Contact"
				]
			}

			//if search term contains 2 dashes, it might be a job invoice num, so strip it down to job num
			let segments = terms.split("-")
			if (segments.length > 2)
				params.filters.push(["job_num",segments[0]+"-"+segments[1],"or","like"])

			let invoiceParams = {
				filters: [
					["standalone_num",terms,"and","like"],
					["manual_invoice_number",terms,"or","like"]
				],
				include: [
					{model:"Service",include:["Contact"]},
					"Contact",
					{model: "ServiceContract",fields: ["id","slug","contract_num","contract_description"]}
				]
			}
			
			vm.spinner(true)

			let promises = [
				this.getJSON("Service/get",params),
				this.getJSON("ServiceInvoice/get",invoiceParams),
				this.getJSON("Job/get",params)
			]

			Promise.all(promises).then(responses => {
				vm.spinner(false)

				if (responses[0].success) {
					//filter to services that have an invoice

					let jobInvoices = []
					responses[2].data.forEach(job => {

						if (job.JobInvoice) {
							job.JobInvoice.forEach(inv => {
								inv.Job = job

								jobInvoices.push(inv)
							})
						}
					})

					let concattedInvoices = [
						...responses[0].data.filter(service => "ServiceInvoice" in service && service.ServiceInvoice).map(service => {return vm.flipInvoiceAndService(service)}),
						...responses[1].data,
						...jobInvoices
					]

					//remove duplicates
					let finalMerged = []
					concattedInvoices.forEach(inv => {
						if (!finalMerged.find(mergedInv => mergedInv.id == inv.id))
							finalMerged.push(inv)
					})

					vm.$store.invoices = finalMerged

					this.numInvoices = vm.$store.invoices.length
					this.page = false //turn off the pagination for search
				}
			})
		},
		fetchInvoices(spinner,orders,addToList) {
			let vm = this

			if (spinner)
				vm.spinner(true)

			if (!this.page)
				this.page = 1 //if pagination is turned off, turn it back on at page 1

			let serviceFilters = [], jobFilters = []

			if (this.invoiceFilter == "all") {
				serviceFilters = [
					['issue_date !=',null],
					["is_quote",0],
				]

				if (this.filterQBOUnpushed) 
					serviceFilters.push(["qbo_id",0])

				serviceFilters.push(['is_freeform',1,'or'])
				
				jobFilters = [
					['issue_date !=',null]
				]
			}
			else if (this.invoiceFilter == "current") {
				serviceFilters = [
					['issue_date !=',null],
					['due_date >=',this.moment().format("YYYY-MM-DD")],
					["is_paid",0]
				]

				jobFilters = this.cloneObj(serviceFilters)
			}
			else if (this.invoiceFilter == 'paid') {
				serviceFilters = [
					['is_paid',1]
				]

				jobFilters = this.cloneObj(serviceFilters)
			}
			else {
				let limit = this.moment().subtract(this.invoiceFilter,"days")

				//filters.push(["finalized",1])

				if (this.invoiceFilter == 90) {
					//anything greater than 90 days overdue
					serviceFilters = [
						['issue_date !=',null],
						['due_date <',limit.format("YYYY-MM-DD")],
						["is_paid",0]
					]

					jobFilters = this.cloneObj(serviceFilters)
				}
				else {
					let limitPlus30 = this.moment().subtract(this.invoiceFilter+30,'days')

					serviceFilters = [
						['issue_date !=',null],
						['due_date <',limit.format("YYYY-MM-DD")],
						["due_date >",limitPlus30.format("YYYY-MM-DD")],
						["is_paid",0]
					]

					jobFilters = this.cloneObj(serviceFilters)
				}
		
			}

			if (this.filterMinAmount) {
				let filter = ["grand_total >=",this.filterMinAmount]
				serviceFilters.push(filter)

				if (this.invoiceFilter == 'all') 
					//there is an 'or' in the service filter, so add this to the beginning as well
					serviceFilters.unshift(filter)
				

				jobFilters.push(filter)
			}

			if (this.filterMaxAmount) {
				let filter = ["grand_total <=",this.filterMaxAmount]
				serviceFilters.push(filter)

				if (this.invoiceFilter == 'all') 
					//there is an 'or' in the service filter, so add this to the beginning as well
					serviceFilters.unshift(filter)

				jobFilters.push(filter)
			}

			if (this.filterIssueDateFrom) {
				let filter = ["issue_date >=", this.filterIssueDateFrom]
				serviceFilters.push(filter)

				if (this.invoiceFilter == 'all')
					//there is an 'or' in the service filter, so add this to the beginning as well
					serviceFilters.unshift(filter)

				jobFilters.push(filter)
			}

			if (this.filterIssueDateTo) {
				let filter = ["issue_date <=", this.filterIssueDateTo]
				serviceFilters.push(filter)

				if (this.invoiceFilter == 'all')
					//there is an 'or' in the service filter, so add this to the beginning as well
					serviceFilters.unshift(filter)

				jobFilters.push(filter)
			}

			let quoteFilter = ['is_quote',0]
			serviceFilters.push(quoteFilter)
			if (this.invoiceFilter == 'all') 
				//there is an 'or' in the service filter, so add this to the beginning as well
				serviceFilters.unshift(quoteFilter)

			jobFilters.push(["is_active_version",1])

			if (this.customerFilter) {

				serviceFilters.push(["customer_id",this.customerFilter])

				if (this.invoiceFilter == 'all') 
					//there is an 'or' in the service filter, so add this to the beginning as well
					serviceFilters.unshift(["customer_id",this.customerFilter])

				jobFilters.push(["Job.customer_id",this.customerFilter])
			}
			if (this.invoiceFilter == "draft") {
				let finalizedFilter = ["finalized !=",1]

				serviceFilters.push(finalizedFilter)

				if (this.invoiceFilter == 'all') 
					//there is an 'or' in the service filter, so add this to the beginning as well
					serviceFilters.unshift(finalizedFilter)

				jobFilters.push(finalizedFilter)
			}

			if (this.filterServiceRangeStart) {
				let filter = ["Service.job_num >=",this.filterServiceRangeStart]
				serviceFilters.push(filter)

				if (this.invoiceFilter == 'all') 
					//there is an 'or' in the service filter, so add this to the beginning as well
					serviceFilters.unshift(filter)
			}
			if (this.filterServiceRangeEnd) {
				let filter = ["Service.job_num <=",this.filterServiceRangeEnd]
				serviceFilters.push(filter)

				if (this.invoiceFilter == 'all') 
					//there is an 'or' in the service filter, so add this to the beginning as well
					serviceFilters.unshift(filter)
			}

			if (!orders) {
				orders = [
					['is_processed',"ASC"],
					["due_date","ASC"]
				]
			}

			if (this.filterQBOUnpushed) {
				serviceFilters.push(["qbo_id",0])
				jobFilters.push(["qbo_id",0])
			}

			let params = {
				filters: serviceFilters,
				include: [
					{
						model: "Service",
						fields: ["job_num","job_name","status","Customer","customer_id"],
						include: ["Contact"]
					},
					{
						model: "ServiceContract",
						fields: ["id","slug","contract_num","contract_description","Customer"],
						include: ["Contact"]
					},
					"Contact"
				],
				fields: [
					"due_date",
					"amount_due",
					"grand_total",
					"pretax_total",
					"finalized",
					"is_finalized",
					"is_paid",
					"is_processed",
					"issue_date",
					"is_quote",
					"last_issued",
					"updated_at",
					"updated_by",
					"seen_log_json",
					"amount_paid",
					"revision_num",
					"invoice_num",
					"standalone_num",
					"manual_invoice_number",
					"service_id",
					"service_contract_id",
					"qbo_id",
					'is_freeform',
					"customer_id",
					"Service",
					"Job",
					"Customer"
				],
				orders,
				page: this.page,
				//custom_page_limit: 25
			}

			let promises = []

			if (this.filterJobType != 'project')
				promises.push(vm.getJSON("ServiceInvoice/get",params))

			if (this.filterJobType != 'service') {
				params.include = [{
					model: "Job",
					fields: ["job_num","job_name","Customer","customer_id","date_completed"],
					include: ["Contact"]
				}]
				params.filters = jobFilters

				//remove is_quote filter from jobInvoice params
				let strippedFilters = []
				params.filters.forEach(filter => {
					if (filter[0] != 'is_quote')
						strippedFilters.push(filter)
				})
				params.filters = strippedFilters

				promises.push(vm.getJSON("JobInvoice/get",params))
			}

			return new Promise((resolve,reject) => {

				Promise.all(promises).then(responses => {

					if (spinner)
						vm.spinner(false)

					let invoices = []

					if (vm.filterJobType != 'project') 
						invoices = responses[0].data.filter(inv => inv.Service || inv.ServiceContract || inv.is_freeform == 1)
					
					else if (vm.filterJobType == 'project')
						invoices = responses[0].data

					if (responses.length > 1)
						invoices = invoices.concat(responses[1].data)

					//sort by due date (this will be secondary sort because we're doing it first)
					invoices = invoices.sort((a,b) => {
						if (vm.moment(a.due_date).isAfter(vm.moment(b.due_date)))
							return 1
						else
							return -1
					})

					//sort by processed
					invoices = invoices.sort((a,b) => {
						if (a.is_processed == 0 && b.is_processed == 1)
							return -1
						else if (a.is_processed == 1 && b.is_processed == 0)
							return 1
						else
							return 0
					})

					if  (addToList) {
						vm.$store.invoices = [
							...vm.$store.invoices,
							...invoices
						]
					}
					else
						vm.$store.invoices = invoices

					vm.numInvoices = 0
					vm.numPages = 1

					if ("meta" in responses[0])
						vm.numInvoices = +responses[0].meta.num_results

					if (responses.length > 1) {
						vm.numInvoices += +responses[1].meta.num_results

						if ("meta" in responses[0]) {
							if (responses[0].meta.num_pages > responses[1].meta.num_pages)
								vm.numPages = responses[0].meta.num_pages
							else
								vm.numPages = responses[1].meta.num_pages
						}
					}
					else if ("meta" in responses[0])
						vm.numPages = responses[0].meta.num_pages

					resolve(responses)
				})
			})
		},
		fetchData() {
			let vm = this

			this.spinner(true)

			let promises = [
				this.fetchInvoices(false)
			]

			if (this.$store.customerOptions.length == 0)
				promises.push(this.fetchCustomers(true,false))

			Promise.all(promises).then(responses => {
				vm.spinner(false)
			})
		}
	
	},
	created() {
		this.fetchData()
		this.$store.lastRoute = this.$route.path

	}

}
</script>

<style type="text/css">

</style>